import truncate from 'lodash/truncate';

export function truncateText(text: string, maxLength = 50): string {
  return truncate(text, { length: maxLength, omission: '...' });
}
